<template>
  <div class="m-layout-silder"
    :style="{
      width: silderWidth,
      background: background,
      color: color
    }"
    >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'm-silder',
  props: {
    width: [String, Number],
    background: String,
    color: String
  },
  computed: {
    silderWidth () {
      if (typeof this.width === 'undefined') return
      if (/(px|%)/.test(this.width.toString())) return this.width
      return this.width + 'px'
    }
  }
}
</script>